import { parsePhoneNumberFromString } from 'libphonenumber-js'


export const intToBool = (num: number | boolean) => {
  if (num === true || num === false) {
    return num
  }
  else return (num === 1 || num === 3) ? true : false
}
export const boolToInt = (bool: boolean | number) => {
  return bool ? 1 : 0
}

export function isNumber(number: number) {
  if (number && !Number.isNaN(number)) {
    return number
  }
  return 0
}

// Parsing a number is the most expensive string operation we do, and the same
// handful of numbers are formatted over and over - once per row of a member
// list, on every keystroke of a search. The result depends on nothing but the
// input, so it is worth remembering. The map holds one entry per distinct
// number seen, which is bounded by the size of the community.
const formattedPhones = new Map<string, string>()

export function formatIfPhoneNumber(data: string) {
  if (!data) return ''

  const remembered = formattedPhones.get(data)
  if (remembered !== undefined) return remembered

  let formatted = data
  if (!data.includes('@')) {
    const number = parsePhoneNumberFromString(data, 'IL')
    if (number)
      formatted = number.formatNational()
  }

  formattedPhones.set(data, formatted)
  return formatted
}

export const intToHex = (color: number) => {
  return '#' + color.toString(16)
}